import { InjectionToken } from '@angular/core';
import { ShellConfig } from './shell-config';

export const SHELL_CONFIG = new InjectionToken<ShellConfig>('selfaiPlatformShellConfig', {
  factory: () => {
    return new ShellConfig();
  },
});
